let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drzY7")).then(() => parcelRequire('fIeJ4'));